import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Typography, Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { STATUS } from "../../../redux/constants";
import { schemeValidation } from "./schema";
import {
  getAssessmentPeriod,
  resetAddCombustionStatus,
  updateSupplierScreening,
} from "../../../redux/actions";
import CeroButton from "../../../components/CeroButton";
import CeroSelect from "../../../components/CeroSelect";
import CeroInput from "../../../components/CeroInput";
import useStyles from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CeroAutoComplete from "../../../components/CeroAutoComplete";
import { sampleYear } from "../../../constants";
import CeroChipSelect from "../../../components/CeroChipSelect";

const EditSupplierScreeningForm = (props) => {
  const { emissionData, onCancel } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [showOtherDetailsSocial, setShowOtherDetailsSocial] = useState(false);

  const updateEmissionData = useSelector(
    (state) => state.emission.updateSupplierScreening
  );

  const formik = useFormik({
    initialValues: {
      facility: emissionData.facility_id || "",
      year: emissionData.year || "",
      assessmentPeriod: emissionData.assessment_period || "",
      environmentalCriteria: emissionData.environment_criteria
        ? emissionData.environment_criteria.split(",")
        : [],
      environmentalSuppliers:
        emissionData.suppliers_screened_using_env_criteria || "",
      otherDetails: emissionData.enviormental_criteria_details || "",
      describeEnvironmentalImpact: emissionData.negative_env_impact || "",
      actionsToNegative: emissionData.action_taken_address_env_criteria || "",
      socialCriteria: emissionData.social_criteria
        ? emissionData.social_criteria.split(",")
        : [],
      socialSuppliers:
        emissionData.suppliers_screened_using_social_criteria || "",
      otherDetailsSocial: emissionData.supplier || "",
      describeSocialImpact: emissionData.negative_social_impact || "",
      actionsToNegativeImpact:
        emissionData.action_taken_address_social_criteria || "",
    },
    validationSchema: schemeValidation,
    onSubmit: () => {},
  });

  useEffect(() => {
    if (formik.values.environmentalCriteria.includes("Others")) {
      setShowOtherDetails(true);
    } else {
      setShowOtherDetails(false);
    }
  }, [formik.values.environmentalCriteria]);

  useEffect(() => {
    if (formik.values.socialCriteria.includes("Others")) {
      setShowOtherDetailsSocial(true);
    } else {
      setShowOtherDetailsSocial(false);
    }
  }, [formik.values.socialCriteria]);

  const facilitiesData = useSelector(
    (state) => state.listings.listFacilities.data
  );

  const facilitiesList = facilitiesData.map((item) => ({
    key: item.id,
    value: item.name,
  }));

  const assessmentData = useSelector(
    (state) => state.assessment.assessmentPeriod.data
  );

  const assessmentOptions = Array.isArray(assessmentData)
    ? assessmentData.map((item) => ({
        key: item.period,
        value: item.period,
      }))
    : [];

  const yearList = sampleYear().map((item) => ({
    id: item.key,
    label: item.value,
  }));

  useEffect(() => {
    const { facility, year } = formik.values;
    if (facility && year) {
      dispatch(
        getAssessmentPeriod(
          year,
          facility,
          "supplier_screening_using_enviormental_social_criteria",
          emissionData.id
        )
      );
    }
  }, [formik.values, dispatch]);

  useEffect(() => {
    if (updateEmissionData.status === STATUS.SUCCESS) {
      enqueueSnackbar("Supplier screening updated successfully", {
        variant: "success",
      });
      dispatch(resetAddCombustionStatus());
      onCancel();
    } else if (updateEmissionData.status === STATUS.ERROR) {
      enqueueSnackbar(
        updateEmissionData.message.message ||
          "We couldn't process your request. Please try again later.",
        { variant: "error" }
      );
      dispatch(resetAddCombustionStatus());
    }
  }, [updateEmissionData, dispatch, enqueueSnackbar, onCancel]);

  const onUpdateSupplierScreening = () => {
    const requestData = {
      id: emissionData.id,
      facility_id: formik.values.facility,
      assessment_period: formik.values.assessmentPeriod,
      year: formik.values.year,
      environmental_criteria: formik.values.environmentalCriteria,
      enviormental_criteria_details: formik.values.otherDetails,
      suppliers_screened_using_env_criteria:
        formik.values.environmentalSuppliers,
      negative_env_impact: formik.values.describeEnvironmentalImpact,
      action_taken_address_env_criteria: formik.values.actionsToNegative,
      social_criteria: formik.values.socialCriteria,
      social_criteria_details: formik.values.otherDetailsSocial,
      suppliers_screened_using_social_criteria: formik.values.socialSuppliers,
      negative_social_impact: formik.values.describeSocialImpact,
      action_taken_address_social_criteria:
        formik.values.actionsToNegativeImpact,
      save: true,
    };
    dispatch(updateSupplierScreening(requestData));
  };

  const environmentalCriterias = {
    "Emission Reduction": "Emission Reduction",
    "Energy Efficiency": "Energy Efficiency",
    "Environmental Complaince": "Environmental Complaince",
    "Renewable Energy Usage": "Renewable Energy Usage",
    "Sustainable Sourcing": "Sustainable Sourcing",
    "Waste Management": "Waste Management",
    "Water Conservation": "Water Conservation",
    Others: "Others",
  };

  const socialCriterias = {
    "Child Labour": "Child Labour",
    Employment: "Employment",
    "Forced or Compulsary Labor": "Forced or Compulsary Labor",
    "Occupational Health & Safety": "Occupational Health & Safety",
    Others: "Others",
  };

  const environmentalHandleChange = (event) => {
    const value = event.target.value;
    formik.setFieldValue("environmentalCriteria", value);
  };

  const socialHandleChange = (event) => {
    const value = event.target.value;
    // setSelectedSocial(value);
    formik.setFieldValue("socialCriteria", value);
  };

  return (
    <>
      <div className={classes.backContainer} onClick={onCancel}>
        <ArrowBackIosIcon />
        Back
      </div>
      <Container className={classes.container}>
        <Box className={classes.innerContainer}>
          <Typography className={classes.title} variant="h6" component="div">
            Edit Supplier Screening using Environmental and Social criteria
          </Typography>
          <Box>
            <Grid
              container
              direction="row"
              wrap="nowrap"
              justifyContent="space-between"
              spacing={8}
            >
              <Grid item container direction="column" md={6} xs={12}>
                <CeroSelect
                  required
                  id="facility"
                  name="facility"
                  label="Facility"
                  fullWidth
                  options={facilitiesList}
                  selectedValue={formik.values.facility}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.facility && formik.errors.facility}
                />
              </Grid>
              <Grid item container direction={"column"} md={6} xs={12}>
                <CeroAutoComplete
                  required
                  id="year"
                  label="Year"
                  onChange={(e, value) =>
                    formik.setFieldValue("year", value.id)
                  }
                  onBlur={formik.handleBlur}
                  error={formik.errors.year}
                  options={yearList}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={formik.values.year}
                />
              </Grid>
              <Grid item container direction="column" md={6} xs={12}>
                <CeroSelect
                  required
                  id="assessmentPeriod"
                  name="assessmentPeriod"
                  label="Assessment Period"
                  fullWidth
                  options={assessmentOptions}
                  selectedValue={formik.values.assessmentPeriod}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.assessmentPeriod &&
                    formik.errors.assessmentPeriod
                  }
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              wrap="nowrap"
              justifyContent="space-between"
              spacing={8}
            >
              <Grid item container direction="column" md={4} xs={6}>
                <CeroChipSelect
                  required
                  id="environmentalCriteria"
                  name="environmentalCriteria"
                  label={"Environmental Criteria"}
                  formControlClass={classes.MultiSelectformControl}
                  optionsde={environmentalCriterias}
                  selected={formik.values.environmentalCriteria}
                  handleChange={(e) => environmentalHandleChange(e)}
                  error={
                    formik.touched.environmentalCriteria &&
                    formik.errors.environmentalCriteria
                  }
                  value={formik.values.environmentalCriteria}
                  classes={{ justCheckSelected: classes.justCheckSelected }}
                />
              </Grid>
              <Grid item container direction="column" md={8} xs={6}>
                <CeroInput
                  required
                  id="environmentalSuppliers"
                  name="environmentalSuppliers"
                  label="Number of Suppliers screened using Environmental Criteria"
                  fullWidth
                  value={formik.values.environmentalSuppliers}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.environmentalSuppliers &&
                    formik.errors.environmentalSuppliers
                  }
                />
              </Grid>
            </Grid>
            {showOtherDetails && (
              <CeroInput
                id="otherDetails"
                name="otherDetails"
                label="Environmental Criteria Details"
                fullWidth
                value={formik.values.otherDetails}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            )}
            <Grid
              container
              direction="row"
              wrap="nowrap"
              justifyContent="space-between"
              spacing={8}
            >
              <Grid item container direction="column">
                <CeroInput
                  required
                  id="describeEnvironmentalImpact"
                  name="describeEnvironmentalImpact"
                  label="Describe Negative Environmental Impacts"
                  fullWidth
                  multiline
                  rows="2"
                  value={formik.values.describeEnvironmentalImpact}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.describeEnvironmentalImpact &&
                    formik.errors.describeEnvironmentalImpact
                  }
                  classes={{ container: classes.textAreaContainer }}
                />
              </Grid>
            </Grid>
            <Grid item container direction="column">
              <CeroInput
                required
                id="actionsToNegative"
                name="actionsToNegative"
                label="Actions Taken to Address Negative Environmental Impacts"
                fullWidth
                multiline
                rows="2"
                value={formik.values.actionsToNegative}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actionsToNegative &&
                  formik.errors.actionsToNegative
                }
                classes={{ container: classes.textAreaContainer }}
              />
            </Grid>
            <Grid
              container
              direction="row"
              wrap="nowrap"
              justifyContent="space-between"
              spacing={8}
            >
              <Grid item container direction="column" md={4} xs={6}>
                <CeroChipSelect
                  required
                  id="socialCriteria"
                  name="socialCriteria"
                  label={"Social Criteria"}
                  formControlClass={classes.MultiSelectformControlsocial}
                  optionsde={socialCriterias}
                  selected={formik.values.socialCriteria}
                  handleChange={(e) => socialHandleChange(e)}
                  error={
                    formik.touched.socialCriteria &&
                    formik.errors.socialCriteria
                  }
                  classes={{
                    justCheckSelected: classes.justCheckSelectedSocial,
                  }}
                />
              </Grid>
              <Grid item container direction="column" md={8} xs={6}>
                <CeroInput
                  required
                  id="socialSuppliers"
                  name="socialSuppliers"
                  label="Number of Suppliers screened using Social Criteria"
                  fullWidth
                  value={formik.values.socialSuppliers}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.socialSuppliers &&
                    formik.errors.socialSuppliers
                  }
                />
              </Grid>
            </Grid>
            {showOtherDetailsSocial && (
              <CeroInput
                id="otherDetailsSocial"
                name="otherDetailsSocial"
                label="Social Criteria Details"
                fullWidth
                value={formik.values.otherDetailsSocial}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            )}
            <Grid
              container
              direction="row"
              wrap="nowrap"
              justifyContent="space-between"
              spacing={8}
            >
              <Grid item container direction="column">
                <CeroInput
                  required
                  id="describeSocialImpact"
                  name="describeSocialImpact"
                  label="Describe Negative Social Impacts"
                  fullWidth
                  multiline
                  rows="2"
                  value={formik.values.describeSocialImpact}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.describeSocialImpact &&
                    formik.errors.describeSocialImpact
                  }
                  classes={{ container: classes.textAreaContainer }}
                />
              </Grid>
            </Grid>
            <Grid item container direction="column">
              <CeroInput
                required
                id="actionsToNegativeImpact"
                name="actionsToNegativeImpact"
                label="Actions Taken to Address Negative Social Impacts"
                fullWidth
                multiline
                rows="2"
                value={formik.values.actionsToNegativeImpact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actionsToNegativeImpact &&
                  formik.errors.actionsToNegativeImpact
                }
                classes={{ container: classes.textAreaContainer }}
              />
            </Grid>
          </Box>
        </Box>
        <Box className={classes.buttonContainer}>
          <CeroButton
            buttonText="Update"
            disabled={!formik.dirty || !formik.isValid}
            className={clsx(classes.button, classes.buttonPrimary)}
            onClick={onUpdateSupplierScreening}
          />
          <CeroButton
            buttonText="Clear"
            variant="outlined"
            className={clsx(classes.button, classes.buttonSecondary)}
            onClick={formik.resetForm}
          />
        </Box>
      </Container>
    </>
  );
};

export default EditSupplierScreeningForm;
